import { ChevronLeft, ChevronRight, Filter, TriangleIcon } from 'lucide-react';
import React from 'react';
import { FiRefreshCw, FiTriangle } from 'react-icons/fi';

const ContentNavBar = ({ currentRange, onRangeChange, refreshAnalytics }) => {
  return (
    <div className="flex items-center justify-between p-4  rounded-lg">
      <div className="flex items-center">
        <h1 className="text-xl font-bold text-white">
          Welcome back, User! <span className="text-black">{currentRange}</span>
        </h1>
        {/* <span className="ml-4 text-gray-600">Shared to:</span>
        <span className="ml-1 text-gray-800 font-medium">Your Group Name</span> */}
      </div>

      <div className="flex items-center space-x-2">
        <button
          onClick={refreshAnalytics}
          className="flex items-center px-4 py-2 bg-[#D9D9D9] text-gray-600 rounded-lg hover:bg-[#FD5F20] hover:text-white transition"
        >
          <FiRefreshCw className="mr-2" />
        </button>
        <button
          onClick={() => onRangeChange('Today')}
          className="flex px-4 py-2 text-sm bg-[#D9D9D9] text-gray-600 rounded-lg hover:bg-[#FD5F20] hover:text-white transition"
        >
          Shared to: <FiTriangle/>
        </button>
        <button
          onClick={() => onRangeChange('Today')}
          className="px-4 py-2 text-sm bg-[#D9D9D9] text-gray-600 rounded-lg hover:bg-[#FD5F20] hover:text-white transition"
        >
          Today
        </button>
        
        <button
          onClick={() => onRangeChange('This Week')}
          className="px-4 py-2 text-sm bg-[#D9D9D9] text-gray-600 rounded-lg hover:bg-[#FD5F20] hover:text-white transition"
        >
          This Week
        </button>
        <button
          onClick={() => onRangeChange('This Month')}
          className="px-4 py-2 text-sm bg-[#D9D9D9] text-gray-600 rounded-lg hover:bg-[#FD5F20] hover:text-white transition"
        >
          This Month
        </button>
        <div className="flex items-center space-x-1">
          <span className="text-gray-600">Sort by:</span>
          <select className="border rounded p-1 text-sm text-gray-700 bg-white">
            <option>This Week</option>
            <option>This Month</option>
            <option>Last Month</option>
          </select>
        </div>
        <button className="p-2 text-gray-600 bg-[#D9D9D9] hover:bg-[#FD5F20] rounded-lg transition">
          <Filter className="h-5 w-5" /> {/* Replace with actual filter icon */}
        </button>
        <button className="p-2 text-gray-600 bg-[#D9D9D9] hover:bg-[#FD5F20] rounded-lg transition">
          <Filter className="h-5 w-5" /> {/* Replace with actual more options icon */}
        </button>
        <button className="p-2 text-gray-600 bg-[#D9D9D9] hover:bg-[#FD5F20] rounded-lg transition">
          <Filter className="h-5 w-5" /> {/* Replace with actual more options icon */}
        </button>
      </div>
    </div>
  );
};

export default ContentNavBar;